import React from 'react';

import { Select, SelectProps } from '../Select/Select';

import { FaUserNinja, FaUserTie, FaUser } from "react-icons/fa";
import { FiUser } from 'react-icons/fi';

const PermisaoSelect: React.FunctionComponent<SelectProps> = (props) => {
  return <Select
    {...props}
    placeholder="Defina o tipo de permissão..." 
    options={[
      { label: "Sem permissão", value: -1, icone: <FiUser aria-hidden={true} /> },
      { label: "Nível 1", value: 1, icone: <FaUser aria-hidden={true} /> },
      { label: "Nível 2", value: 2, icone: <FaUserTie aria-hidden={true} /> },
      { label: "Administrador do Sistema", value: 3, icone: <FaUserNinja aria-hidden={true} /> },
    ]} 
    inputId="permissao" />
}


export default PermisaoSelect;